import { z } from 'zod'

import { checkInvalidAmount, toSolanaPublicKey } from '../utils'

export const solanaTransferSchema = z
    .object({
        amount: z.string().default(''),
        recipient: z
            .string()
            .min(1, 'Recipient address is required')
            .refine((value) => toSolanaPublicKey(value), {
                message: 'Invalid Solana address',
            }),
        balance: z.bigint().default(0n),
    })
    .superRefine((data, ctx) => {
        if (data.amount) {
            const validationResult = checkInvalidAmount({
                value: data.amount,
                balance: data.balance,
                decimals: 9,
            })
            if (validationResult) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: validationResult.message,
                    path: ['amount'],
                })
            }
        }
    })

export type SolanaTransferSchema = z.infer<typeof solanaTransferSchema>
